import api from '../../api/index.api'
import StatisticTypes from './statistic.types'

export const onGetPercentWordDontHaveDefinitionWithInterval = (
	interval,
	cb
) => {
	return async dispatch => {
		try {
			const result = await api.statisticApi.getPercentWordDontHaveDefinitionWithInterval(
				{ interval, isGetPrev: true }
			)
			dispatch({
				type: StatisticTypes.GET_PERCENT_WORD_DONT_HAVE_DEFINITION,
				payload: result,
			})
			cb && cb(true, result)
		} catch (err) {
			console.log(err)
			cb && cb(false, err.message)
		}
	}
}
